export function newApplicationsInfluxDays() {
    return axios.get(route('api.manage.companies.system-parameters.new-applications-influx-days'))
        .then(({data}) => data);
}

export function newApplicationsInfluxThreshold() {
    return axios.get(route('api.manage.companies.system-parameters.new-applications-influx-threshold'))
        .then(({data}) => data);
}

export function latestApplicationsInflux() {
    return axios.get(route('api.manage.companies.system-parameters.latest-applications-influx'))
        .then(({data}) => data);
}
